
import { formatPrice } from '@/modules/Helpers';
import { mapGetters, mapMutations } from 'vuex';

export default {
    props: {
        originalPrice : {type: Number, required: false},
        discount: {type: Number, required: false},
        coupon: {type: Object, required: false},
        order: {type: Object, required: false},
    },
    computed: {
        ...mapGetters(['vat']),
    },
    methods: {
        ...mapMutations('order', [
            'removeCoupon'
        ]),
        formatPrice,
        showDescription (coupon) {
            alert(coupon.description_text);
        },
        calcOriginalPrice (price) {
            return formatPrice(price);
        },
        calcDiscount (price) {
            return formatPrice(price);
        }
    },
};
